<template>
  <div
    class="px-2 py-0.5 space-x-0.5 rounded-full border inline-flex items-center"
    :class="[getSize, getColorClass, wrapperClass]"
  >
    <fa
      v-if="icon.length"
      :icon="icon"
      :class="[getIconColorClass, iconClass]"
      class="fa-fw text-xs mr-1"
    />
    <slot name="label" />
    <fa
      v-if="rightIcon.length"
      :icon="rightIcon"
      :class="getIconColorClass"
      class="fa-fw text-xs"
    />
    <fa
      v-else-if="tooltip"
      v-tippy="{ zIndex: 999999999999 }"
      :icon="['fal', 'circle-question']"
      :content="tooltip"
      :class="[getTooltipSize, getIconColorClass]"
      class="ml-1 focus:outline-none focus:ring text-nowrap"
    />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons';

library.add(faCircleQuestion);

export default {
  name: 'VetsterOutlineBadge',

  props: {
    color: {
      type: String,
      default: 'green',
    },
    icon: {
      type: Array,
      default: () => [],
    },
    iconColor: {
      type: String,
      default: 'green',
    },
    iconClass: {
      type: String,
      default: '',
    },
    rightIcon: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'tight',
    },
    tooltip: {
      type: String,
      default: null,
    },
    wrapperClass: {
      type: String,
      default: '',
    },
  },

  computed: {
    getIconColorClass() {
      switch (this.iconColor) {
        case 'plus':
          return 'text-bubblegum-500';
        case 'red':
          return 'text-red-700';
        case 'yellow':
          return 'text-yellow-900';
        case 'ocean':
          return 'text-ocean-700';
        case 'neutral':
          return 'text-neutral-900';
        case 'green':
        default:
          return '';
      }
    },
    getColorClass() {
      switch (this.color) {
        case 'plus':
          return 'bg-white border-bubblegum-500 text-neutral-900';
        case 'red':
          return 'text-red-700 bg-red-50 border-red-600/10';
        case 'yellow':
          return 'text-yellow-900 bg-yellow-50 border-yellow-200';
        case 'ocean':
          return 'text-ocean-700 bg-ocean-50 border-ocean-200';
        case 'neutral':
          return 'text-neutral-900 bg-neutral-50 border-neutral-200';
        case 'green':
        default:
          return 'bg-green-50 border-green-200 text-green-700';
      }
    },
    getSize() {
      switch (this.size) {
        case 'lg':
          return 'font-medium text-sm leading-5 py-2';
        case 'sm':
          return 'text-xs leading-4 py-1';
        case 'tight':
          return 'text-xs leading-4 py-0.5';
        default:
          return 'text-xs leading-4 py-2';
      }
    },
    getTooltipSize() {
      switch (this.size) {
        case 'lg':
          return 'text-lg';
        case 'sm':
          return 'text-sm';
        case 'tight':
          return 'text-xs';
        default:
          return 'text-base';
      }
    },
  },
};
</script>
